import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import bg from "../../Assets/mo.jpeg";
import { CiReceipt } from "react-icons/ci";

const PrintMOForm = ({ orders }) => {
    const contentRef = useRef(null);

    const reactToPrintFn = useReactToPrint({
        contentRef,
        documentTitle: "MO Print",
        pageStyle:
            `
        @media print {

          @page {
            size: A4;
            margin: 0;
          }

          html, body {
            margin: 0 !important;
            padding: 0 !important;
          }

          .print-wrapper {
            width: 21cm;
            height: 29.7cm;
            margin: 0 auto;
          }

          .print-page {
            width: 14.5cm;
            height: 24.5cm;
            margin: 0 auto;
            position: relative;
            page-break-after: always;
          }

          .print-page:last-child {
            page-break-after: auto;
          }
        }
        `
    });

    const calculateAmount = (amount) => {
        if (!amount) return 0;
        return Number(amount) < 10000
            ? Number(amount) - 75
            : Number(amount) - 100;
    };

    return (
        <>

            <div>
                <button onClick={reactToPrintFn} className="oms-btn oms-btn-primary">
                    <CiReceipt size={15} />
                    Print MO
                </button>

                <div ref={contentRef} className="print-wrapper printContent">
                    {orders?.map((order, index) => (
                        <div key={index} className="print-page">
                            <div
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    // backgroundImage: `url(${bg})`,
                                    backgroundSize: "cover",
                                    backgroundPosition: "center",
                                    backgroundRepeat: "no-repeat",
                                    position: "relative",
                                }}
                            >
                                {/* Top Left */}
                                <div
                                    style={{
                                        position: "absolute",
                                        top: "10px",
                                        left: "30px",
                                        fontSize: "18px",
                                        fontWeight: "bold",
                                    }}
                                >
                                    Nazimabad HPO
                                </div>

                                {/* Top Right Amount */}
                                <div
                                    style={{
                                        position: "absolute",
                                        top: "5px",
                                        right: "60px",
                                        fontSize: "18px",
                                        fontWeight: "bold",
                                    }}
                                >
                                    Vpp : {calculateAmount(order?.amount)}/-
                                </div>

                                {/* Tracking ID */}
                                <div
                                    style={{
                                        position: "absolute",
                                        top: "180px",
                                        right: "30px",
                                        fontSize: "14px",
                                        fontWeight: "bold",
                                    }}
                                >
                                    {order?.trackingId}
                                </div>

                                {/* Middle Amount */}
                                <div
                                    style={{
                                        position: "absolute",
                                        top: "320px",
                                        right: "220px",
                                        fontSize: "14px",
                                        fontWeight: "bold",
                                    }}
                                >
                                    {calculateAmount(order?.amount)}/-
                                </div>

                                {/* Customer Details */}
                                <div
                                    style={{
                                        position: "absolute",
                                        top: "370px",
                                        left: "30px",
                                        fontSize: "14px",
                                        fontWeight: "bold",
                                        maxWidth: "400px",
                                        wordBreak: "break-word",
                                    }}
                                    className="text-center"
                                >
                                    {order?.customerName}
                                    <br />
                                    {order?.address}
                                    <br />
                                    {order?.city}
                                    <br />
                                    {/* <br /> */}

                                    (Bulk User) <br />
                                    AR E-Cart P.O Box No. 2110 <br />
                                    Nazimabad HPO Karachi <br />
                                    03004919318 (42401-3492314-3)
                                </div>

                                {/* Bottom Section */}
                                <div
                                    style={{
                                        position: "absolute",
                                        bottom: "20px",
                                        left: "40px",
                                        fontSize: "16px",
                                        fontWeight: "bold",
                                    }}
                                >
                                    {calculateAmount(order?.amount)}/-
                                    <br />
                                    Order ID : {order?.trackingId}
                                    <br />
                                    {order?.customerName}
                                    <br />
                                    {order?.phoneNumber}
                                    <br />
                                    {order?.createdAt &&
                                        new Date(order.createdAt).toLocaleDateString("en-GB", {
                                            day: "2-digit",
                                            month: "short",
                                            year: "numeric",
                                        })}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default PrintMOForm;